const AILogo = ({ size=15, color="#6aa0d8", ...props }) => (
    <svg width={size} height={size} viewBox="0 0 100 100" {...props}>
        <defs>
            {/* Soft shadow */}
            <filter id="shadow" x="-20%" y="-20%" width="140%" height="140%">
                <feDropShadow dx="0" dy="3" stdDeviation="3" floodColor="#000" floodOpacity="0.15"/>
            </filter>
        </defs>

        {/* Chip base */}
        <rect
            x="10" y="10" width="80" height="80" rx="16" fill="#d9ded6"
            style={{ filter: "drop-shadow(2px 4px 6px rgba(0,0,0,0.15))" }}
        />
        {/* AI Text */}
        <text
            x="50" y="70" textAnchor="middle" fontSize="60" fontWeight="600"
            fill={color} fontFamily="Arial, sans-serif"
        >
            AI
        </text>
    </svg>
);

export default AILogo;
